import axios from 'axios'
import { toAppError } from '@/errors/app-error'

export const httpClient = axios.create()

httpClient.interceptors.response.use(
  (response) => response,
  (error: unknown) => Promise.reject(toAppError(error)),
)
